import React, { Component } from 'react';
import { Button, Container } from 'reactstrap';
import DashTab from '../../components/Admin/dashTab';
import DataTable from '../../components/Admin/tableList';
import PagePath from '../../components/common/pagePath';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import AddAnnounceType from '../../components/Admin/addHebergement'
import Switch from '@mui/material/Switch';
import { addAnn } from "../../slices/modalSlice";
import Calender from '../../components/common/calender';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import httpClient from '../../httpClient';
import moment from "moment";
import { hebergements, removeHebergement } from '../../slices/myAnnoucesSlice';



const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));


class Myannounces extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profile : {},
      hebAnnounces : [],
      carAnnounces :[],
      AnnRows:[],
      tst:""
    };
  }

  async componentDidMount(){
    let profile = await httpClient.getUser(this.props.myId)
    let hebAnnounces = await httpClient.getUserAnnounces(this.props.myId,"accommodations")
    this.props.dispatch(hebergements(hebAnnounces))
    const AnnRowsHeberg =  []
    const AnnRows = []
    await this.props.myAnnounces.hebergement.map((e,i)=>{
      this.setState({
        [e._id] : e.status
      })
      AnnRowsHeberg.push([
        e.title ,
        moment(e.createdAt ).format('DD/MM/YYYY - h:mm'),
        23,
        e.vues,
        <Switch
          defaultChecked={this.state[e._id]}
          onChange={()=>{this.changeStatus(e._id,this.state[e._id])}}
        />,
        <Actions announceId={e._id} index={i} click={(action)=>{if(action==="delete") {
          // this.props.dispatch(removeHebergement(id));
          console.log("reload");
          
        } }}/>
      ])
    })
      this.setState({
      profile : profile,
      hebAnnounces : hebAnnounces,  
      AnnRowsHeberg :AnnRowsHeberg
     })
    let carAnnounces = await httpClient.getUserAnnounces(this.props.myId,"cars")
    this.setState({
      profile : profile,
      hebAnnounces : hebAnnounces,
      carAnnounces :carAnnounces,
      AnnRows :AnnRows
    })
  }

  componentWillReceiveProps(props) {
    const { hebergement } = this.props.myAnnounces;
    console.log(props.myAnnounces.hebergement);
    console.log(hebergement);
    if (props.myAnnounces.hebergement !== hebergement) {
      this.setState({
        test:"test"
      })
    }
  }

  changeStatus(announceId,value){
    this.setState({[announceId]: !this.state[announceId]});
    httpClient.changeStatus(announceId,!value);
  }

   mesItems = ["Mes annonces", "Mes achats", "Mes ventes"];
   categos =  ["Hébergements", "Vols","Visas","Voyages","Véhicules","Divertissement","Toutes"];
   achats = ["À payer", "Expirées", "Payées","Confirmées","En cours","Consommées"];
   ventes =["En attente","Pré-réservation", "Payées","Confirmées","En cours","Historique"]


   openTypeAnnounceForm = () =>{
    this
    .props
    .dispatch(addAnn())
    }


    render() {
      
      const AnnHeadings = [
        <div className="col-8 px-0">
          <Calender returnBool={true}/>
        </div>
        ,
        'Date de dépot',
        'Ventes',
        'Vues',
        'Etat',
      ];
      const AchatHeadings = [
        
        "Commande",
        'Store',
        'Date et heure',
        'Total',
        'Devise',
        "Expiration",
        "Actions"
      ];

      const AnnRowss = [
        [
          'Véhicules : Location de Voiture 4x4 : BMW X5',
          "18/01/2021 - 10:45",
          28,
          23,<Actions />

        ],
        [
          'Véhicules : Location de Voiture 4x4 : BMW X5',
          "18/01/2021 - 10:45",
          28,
          23,
          <Actions />,

        ],
        [
          'Véhicules : Location de Voiture 4x4 : BMW X5',
          "18/01/2021 - 10:45",
          28,
          23,
          <Actions />,

        ],
        [
          'Véhicules : Location de Voiture 4x4 : BMW X5',
          "18/01/2021 - 10:45",
          28,
          23,<Actions />

        ],
      ];

      const AchatRows = [
        [
          'Véhicules : Location de Voiture 4x4 : BMW X5',
          "L&B Tourism",
          "18/01/2021 - 10:45",
          250000,
          "DZD",
          "19/01 - 10:45",
          <Actions />

        ],
        [
          'Véhicules : Location de Voiture 4x4 : BMW X5',
          "L&B Tourism",
          "18/01/2021 - 10:45",
          250000,
          "DZD",
          "19/01 - 10:45",
          <Actions />

        ],
        [
          'Véhicules : Location de Voiture 4x4 : BMW X5',
          "L&B Tourism",
          "18/01/2021 - 10:45",
          250000,
          "DZD",
          "19/01 - 10:45",
          <Actions />

        ],
        [
          'Véhicules : Location de Voiture 4x4 : BMW X5',
          "L&B Tourism",
          "18/01/2021 - 10:45",
          250000,
          "DZD",
          "19/01 - 10:45",
          <Actions />

        ]
      ];
      const cuurentUser = this.props.currentUser

      const AnnRowsHeberg =  []
      const AnnRows = []
      const hbAnnounces = this.props.myAnnounces.hebergement.map((e,i)=>{
        AnnRowsHeberg.push([
          e.title ,
          moment(e.createdAt ).format('DD/MM/YYYY - h:mm'),
          23,
          e.vues,
          <Switch
            defaultChecked={this.state[e._id]}
            onChange={()=>{this.changeStatus(e._id,this.state[e._id])}}
          />,
          <Actions announceId={e._id} index={i} click={(action,id)=>{if(action==="delete") {
            this.props.dispatch(removeHebergement(id));
          } }}/>

        ])
      })
        return (
            <>
             <AddAnnounceType idOwner={cuurentUser._id}/>
            <Container className='mb-5 pb-5'>
                   <PagePath pages={['Acceuil', "Mes annonces"]}/>
                   <div className="shared__header mt-5 d-flex align-items-center col-12  px-0 justify-content-between">
                       <div className='d-flex align-items-center'>
                          <img src="/imgs/dashboard/announces.svg" width="80px" className='mr-4' alt="" />
                          <h1 className='shared_header_txt'>Mes annonces</h1>
                       </div>
                       <div>
                            <Button onClick={this.openTypeAnnounceForm.bind(this)} className='add_ann_btn'><span><img src="/imgs/dashboard/add_white.svg" width="30px" className='mr-2' alt="" /></span><span>Créer</span></Button>
                       </div>
                       
                   </div>

                   <div className='mt-4 '>
                    {(this.state.hebAnnounces.length>0 || this.state.carAnnounces.length>0 )&& <div className="px-0">
                    <DashTab items ={this.mesItems} col="col-8 px-0" search
                    content={[
                     <DashTab items={this.categos}
                      content = {[
                      <DataTable headings={AnnHeadings} rows={AnnRowsHeberg}/>,
                      <DataTable headings={AnnHeadings} rows={AnnRowss} />,
                      <DataTable headings={AnnHeadings} rows={AnnRowss} />,
                      <DataTable headings={AnnHeadings} rows={AnnRowss} />,
                      <DataTable headings={AnnHeadings} rows={AnnRowss} />,
                      <DataTable headings={AnnHeadings} rows={AnnRowss} />,
                      <DataTable headings={AnnHeadings} rows={AnnRowss} />]
                    }
                     />, 
                     <DashTab items={this.achats}
                      content = {[<center className="Cell text-center">En cours de construction :(</center>]}
                     />,
                     <DashTab items={this.ventes}
                      content = {[<center className="Cell text-center">En cours de construction :(</center>]}
                     />
                     ]}
                    />
                    </div>}

                    
                   </div>
            </Container>
                
            </>
        );
    }
}
function mapStateToProps(state) {
  return {    
    myId : state.user.user._id,
    myAnnounces : state.myAnnounces
  }
}
//connect function INJECTS dispatch function as a prop!!
export default connect(mapStateToProps)(Myannounces);

function click(announceId){
  httpClient.deleteAccomodation(announceId);
  window.location.reload(false);
}

function Actions(props) {
  // httpClient.deleteAccomodation(props.announceId)
  return(
    <div className='d-fl'>         
                        <a href="#"  id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                          <img className='mb-2 ' width="5px"  src="/imgs/profile/points.svg" alt="" />
                          </a>
                          <div class="dropdown-menu dropdown-menu-left mt-3" aria-labelledby="dropdownMenuButton">
                            <div style={{cursor:"pointer"}} class="dropdown-item d-flex align-items-center" href="#"><span><img width="15px" src="/imgs/dashboard/edit_action.svg" className=' mr-3' alt="" /></span>Modifier</div>
                            <div style={{cursor:"pointer"}} class="dropdown-item d-flex align-items-center" href="#"><span><img width="15px" src="/imgs/dashboard/renew.svg" className=' mr-3' alt="" /></span>Renouvler</div>
                            <div style={{cursor:"pointer"}} class="dropdown-item d-flex align-items-center" href="#"><span><img width="15px" src="/imgs/dashboard/archv_action.svg" className=' mr-3' alt="" /></span>Archiver</div>
                            <div style={{cursor:"pointer"}} class="dropdown-item d-flex align-items-center" onClick={e=>{click(props.announceId);props.click('delete') }}><span><img width="15px" src="/imgs/dashboard/delete_action.svg" className=' mr-3' alt="" /></span>Supprimer</div>

                            {/* <a class="dropdown-item d-flex align-items-center" href="#" onClick={e=>props.click('hello')}><span><img width="15px" src="/imgs/dashboard/delete_action.svg" className=' mr-3' alt="" /></span>Supprimer</a> */}
                          </div>
          
    </div>
  )
}